import { configureStore } from '@reduxjs/toolkit';
import { baseApi } from '@service/base.api';
import { authenticationReducer } from './authentication/authentication.slice';
import { unauthorizedMiddleware } from './middleware/unauthorized.middleware';

export const reduxStore = configureStore({
  reducer: {
    authentication: authenticationReducer,
    [baseApi.reducerPath]: baseApi.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat([baseApi.middleware, unauthorizedMiddleware]),
});

export type RootState = ReturnType<typeof reduxStore.getState>;
export type AppDispatch = typeof reduxStore.dispatch;
